// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1Q_bP","left":"StickyBox_left__RIxPx","right":"StickyBox_right__1mdFe"};